import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import ArrowLeft from '@r1-frontend/ui-react/components/svg/arrows/ArrowLeft';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { FAQArticle } from '~/src/features/faq/components/FAQArticle';
import { FAQTopicList } from '~/src/features/faq/components/FAQTopicsList';
import { setFAQRedirectLoading } from '~/src/features/faq/store/actionCreators';

import * as ST from './styled';

interface IFaqArticleProps {
    articleQuestion: string,
    articleAnswer: string,
}

const Index = ({ articleQuestion, articleAnswer }: IFaqArticleProps) => {
    const router = useRouter();
    const dispatch = useDispatch();
    const [isShowArticle, setIsShowArticle] = useState(true);
    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    useEffect(() => {
        dispatch(setFAQRedirectLoading(false));
    }, [dispatch]);

    return <>
        <ST.Container>
            <ST.ButtonBack
                animation={false}
                bType={'ghost'}
                Icon={<ArrowLeft/>}
                onClick={() => {
                    dispatch(setFAQRedirectLoading(true));
                    router.push('/faq');
                }}
            >
                Назад
            </ST.ButtonBack>
            <ST.Wrap>
                {((isShowArticle && isMobile) || !isMobile) &&
                <FAQArticle text={articleAnswer} title={articleQuestion}/>}
                <FAQTopicList onChangeMobileView={(value) => setIsShowArticle(!value)}/>
            </ST.Wrap>
        </ST.Container>
    </>;
};

export default Index;
